import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { catchError, finalize, of, throwError } from 'rxjs';
import { FirebaseService } from 'src/app/commons/firebase.service';
import { FunctionsService } from 'src/app/data/functions.service';
import { UploadService } from 'src/app/data/upload.service';
import { environment } from 'src/environments/environment';
import { RegistroClienteComponent } from '../cliente/registro/registro-cliente.component';

@Component({
  selector: 'app-adiciona-lance',
  templateUrl: './adiciona-lance.component.html',
  styleUrls: ['./adiciona-lance.component.css']
})
export class AdicionaLanceComponent implements OnInit {
  @ViewChild('adicionaLanceStepper') adicionaLanceStepper: MatStepper;
  @ViewChild(RegistroClienteComponent) registroClienteComponent: RegistroClienteComponent;
  public loading: boolean = false;
  public adicionaLanceFormGroup: UntypedFormGroup;
  public usuarioEstaLogado: boolean;
  public usuarioJaTemUmaConta: boolean;
  public imagens: Array<string> = [];
  public lanceInserido = null;
  public taxa = 0.0;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public firebase: FirebaseService,
    private formBuilder: UntypedFormBuilder,
    private functions: FunctionsService,
    private uploadService: UploadService
  ) { }

  ngOnInit(): void {
    this.usuarioJaTemUmaConta = false;
    this.usuarioEstaLogado = this.firebase.user ? true : false;
    this.taxa = this.data.taxa || 0.11;
    
    const valor_lance = this.data.melhor_lance ? this.data.melhor_lance - 1  : null;

    const { altura, largura, peso, comprimento } = this.data?.dimensoes;

    const isAlturaRequired = !altura || altura <= 0;
    const isLarguraRequired = !largura || largura <= 0;
    const isComprimentoRequired = !comprimento || comprimento <= 0;
    const isPesoRequired = !peso || peso <= 0;

    this.adicionaLanceFormGroup = this.formBuilder.group({
      valor_lance: [{value: valor_lance, disabled: false}, [
        Validators.min(1),
        Validators.max(valor_lance)
      ]],
      comprimento: [{value: comprimento || 0, disabled: !isComprimentoRequired}, [
        isComprimentoRequired ? Validators.required : [],
        Validators.min(1),
        Validators.max(999999)
      ]],
      altura: [{value: altura || 0, disabled: !isAlturaRequired }, [
        isAlturaRequired ? Validators.required : [],
        Validators.min(1),
        Validators.max(999999)
      ]],
      largura: [{value: largura || 0, disabled: !isLarguraRequired}, [
        isLarguraRequired ? Validators.required : [],
        Validators.min(1),
        Validators.max(999999)
      ]],
      peso: [{value:peso || 0, disabled: !isPesoRequired}, [
        isPesoRequired ? Validators.required : [],
        Validators.min(0.01),
        Validators.max(999999)
      ]],
      retirada_local: [{value: this.data?.retirada_local === false ? false : true, disabled: false}, [
        Validators.required
      ]]      
    });
  }

  registroFinalizado(resultado: string){
    if (resultado === 'login') {
      this.usuarioJaTemUmaConta = true;
      this.usuarioEstaLogado = false;
    } else if(resultado === 'finalizado') {
      this.adicionaLanceStepper.next();
    }
  }

  acessoFinalizado(resultado: string){
    if (resultado === 'registrar') {
      this.usuarioJaTemUmaConta = false;
      this.usuarioEstaLogado = false;
    } else if(resultado === 'finalizado') {
      this.adicionaLanceStepper.next();
    }
  }

  incluirLance() {

    if (this.adicionaLanceFormGroup.invalid) {
      this.adicionaLanceFormGroup.markAllAsTouched();
      alert('Por favor, preencher todos os campos obrigatórios');
      return
    }

    if (this.data.usado == true && (this.imagens.length <= 0)) {
      alert('Por favor, inclua ao menos uma imagem');
      return
    }

    const payload: any = {
      uid: this.data.uid
    };

    Object.keys(this.adicionaLanceFormGroup.controls).forEach(key => {
      payload[key] = this.adicionaLanceFormGroup.controls[key].value;
    });

    payload.imagens = this.imagens;

    this.loading = true;
    this.adicionaLanceFormGroup.disable();

    this.functions.adicionaLance(payload)
    .pipe(
      finalize(() => {
        this.loading = false;
        this.adicionaLanceFormGroup.enable();
      })
    )
    .subscribe({
      next: res => {
        this.adicionaLanceStepper.next();
        this.lanceInserido = {
          ...payload,
          ...res.body.data
        };
      },
      error: (err) => {
        console.error(err.error.message);

        alert('Ops, não conseguimos adicionar o lance.\nMotivo: ' + err.error.message);

      }
    });
  }

  async upload(files: FileList) {

    for ( var file of Array.from( files ) ) {
      const name = `negociacoes/${this.data.uid}/imagens/${this.firebase?.user.uid}/${file.name}`;
      const url =  `${environment.firebase_storage}/o/${encodeURIComponent(name)}?alt=media`;

      this.uploadService.upload
      ({
        name,
        type: file.type,
        file
      })
      .pipe(
        finalize(() => {
          this.loading = false
        })
      )          
      .subscribe({
        next: res => {
          this.imagens.push(url);
        },
        error: (err) => {
          if (err.status == 403) {
            this.imagens.push(url)
          } else {
            alert(`Houve uma falha ao incluir a imagem.\nDetalhe: ${err.message}`)
          }
        }
      })
		}
  }

  excluirImagem(imagem: string) {
    this.imagens = this.imagens.filter((img => {
      return img !== imagem
    }))
  }

  teste() {
    console.info(this.adicionaLanceFormGroup.controls['retirada_local'].value)
  }
}
